export default __webpack_public_path__ + "1766c35.png";